
export default function BR_SplineCurve() {
  
}
